import {Component, ElementRef, forwardRef, Input, OnInit, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DocumentClickedService} from '../../../services/document-clicked.service';

/*
* https://medium.com/@majdasab/implementing-control-value-accessor-in-angular-1b89f2f84ebf
*
* todo add input() placeholder
*  add lege list
* */
@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [{provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SelectComponent), multi: true}],
})
export class SelectComponent implements ControlValueAccessor, OnInit {

  @Input() valueIndex = 'value';
  @Input() labelIndex = 'label';
  @Input() small = false;
  @Input() extended = false;

  @ViewChild('searchField') inputField: ElementRef;
  @ViewChild('elementRef') elementRef: ElementRef;

  selection = [];
  selectedOption;
  closed = true;
  query: any;
  isDisabled;

  constructor(private documentClickedService: DocumentClickedService) {
  }

  _options = [];

  @Input() set options(options) {
    this._options = options;
    for (let i = 0; i < this._options?.length; i++) {
      this._options[i][this.valueIndex] = this._options[i][this.valueIndex] + '';  // this component only works with String indexes of options
      this._options[i][this.labelIndex] = this._options[i][this.labelIndex] + '';  // by concatenating en empty string we ensure the name is of type string
    }
    this.query = this.formatSelectedOption(this.selectedOption);
    this.countSelection(this.query);
  }

  /*
 * for example: (option: any) => option.name + ' | ' + option.phone;
 * */
  @Input() labelFormatter = (option: any) => option[this.labelIndex];

  ngOnInit(): void {
    this.documentClickedService.clicked
      .subscribe(target => this.onClick(target));
  }


  propagateChange = (_: any) => {
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  writeValue(selectedOption: any) {
    this.closed = true;
    this.selectedOption = selectedOption + '';
    this.query = this.formatSelectedOption(this.selectedOption);
    this.countSelection(this.query);
  }

  formatSelectedOption(selectedOption) {
    if (this._options === undefined || this._options === null || selectedOption === undefined || selectedOption === null) {
      return '';
    }
    const result = this._options.filter(option => option[this.valueIndex] === selectedOption);
    return result.length === 1 ? this.labelFormatter(result[0]) : '';
  }

  select(option) {
    if (this.isDisabled) {
      return;
    }
    this.writeValue(option[this.valueIndex]);
    this.propagateChange(option[this.valueIndex]);
  }

  selected(option, query) {
    return !(query == null || query === '') &&
      this.labelFormatter(option).toLowerCase().indexOf(query.toLowerCase()) !== -1;
  }

  countSelection(search) {
    const selection = [];
    if (search == null || search === '' || !this._options) {
      return;
    }
    for (const option of this._options) {
      if (this.selected(option, search)) {
        selection.push(option);
      }
    }
    this.selection = selection;
  }

  keydown($event: KeyboardEvent) {
    if ($event.key === 'Enter' && this.selection.length === 1) {
      this.select(this.selection[0]);
    }
  }

  open() {
    this.closed = false;
    window.setTimeout(() => this.inputField.nativeElement.focus(), 10);
  }

  close() {
    this.closed = true;
    this.query = this.formatSelectedOption(this.selectedOption);
    this.countSelection(this.query);
  }

  onClick(target: HTMLElement) {
    if (this.closed === false && !this.elementRef.nativeElement.contains(target)) {
      this.close();
    }
  }
}
